const buildMetaTags = ({ description = '', keywords = '', robots = '', title = ''}) => {
  return ([
    {
      name: 'description',
      content: description
    },
    {
      name: 'keywords',
      content: keywords
    },
    {
      name: 'robots',
      content: robots
    },
    {
      property: 'og:title',
      content: title
    },
    {
      property: 'og:type',
      content: 'article'
    },
    {
      property: 'og:description',
      content: description
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      name: 'twitter:description',
      content: description
    },
    {
      name: 'twitter:title',
      content: title
    }
  ]);
};

export { buildMetaTags };



// WEBPACK FOOTER //
// ./app/utils/SeoUtils.js